// Ported (trimmed) from LC2 (src/commons/constants/residentsInfoConstants.js) — only
// `hasApplied` is needed so far (CampaignInfo's "Stake Checking residents" stat).
export const hasApplied = [
    'ApplicationPending',
    'ApplicationPendingIDVerification',
    'ApplicationPendingAddressVerification',
    'ApplicationPendingSSNVerification',
    'ApplicationApproved',
    'DepositAccountCreated',
    'DebitCardRequested',
    'DebitCardActivated'
];
